import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";

const ThankYou = ({ onReject }) => {
  const months = [
    "",
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  const { candidateStatus } = useSelector((state) => state?.candidateState);
  const [joiningDay, joiningMonth, joiningYear] =
    candidateStatus && candidateStatus?.joining_date?.split("-");

  return (
    <>
      <Box
        textAlign="center"
        sx={{ display: "flex", flexDirection: "column", my: 5 }}
      >
        <Typography variant="h4" color="initial" mb={2} fontWeight={600}>
          Congratulations !
        </Typography>

        <Typography
          variant="subtitle1"
          component="span"
          color="text.primary"
          fontWeight="bold"
        >
          {`We are happy to onboard you as`}
          <Typography component="span" color="#FF435B" fontWeight={600}>
          {' '} {candidateStatus?.designation}{' '}
          </Typography>
          {`on 
           ${joiningDay} ${months[parseInt(joiningMonth)]} ${joiningYear}`}
        </Typography>
      </Box>
      <Box>
        <Typography component="span" color="text.secondary" variant="body2">
          Note: In case you change your mind and want to reject this offer
          <Button
            color="primary"
            size="small"
            variant="text"
            onClick={() => onReject()}
          >
            Click Here
          </Button>
        </Typography>
      </Box>
    </>
  );
};

export default ThankYou;
